module.exports = __webpack_public_path__ + "static/media/DSCF1498-2.463557cd.jpg";